import React from 'react';
import {get, post} from '../../utils/request';
import {Spinner} from 'react-bootstrap';
import Alert from "../../component/Alert/Alert";
import BucketsNav from "../../component/BucketsNav/BucketsNav";
import Container from "../../component/Container/Container";
import Layout from "../../component/Layout/Layout";
import Link from "../../component/Link/Link";
import DeleteBucketModal from "./DeleteBucketModal";
import {faArrowCircleLeft} from "@fortawesome/free-solid-svg-icons";
import "../../component/Table/Table.scss";
import './buckets.scss';

const homepageUrl = `${process.env.REACT_APP_HOMEPAGE_URL}`;

class BucketDeletePage extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            name: this.props.match.params.name,
            location: this.props.match.params.location,
            data: {},
            errorMessage: "",
            loading: true,
            loadingSuccess: false
        };

        this.loadData = this.loadData.bind(this);
        this.deleteBucket = this.deleteBucket.bind(this);
    }

    async componentDidMount() {
        await this.loadData();
    }

    async loadData() {
        if (!this.state.location) {
            return;
        }

        const [res, err] = await get(this, "/auth/bucket/" + this.state.name + "/in/" + this.state.location);
        if (err) {
            this.setState({errorMessage: "error: " + err, loading: false});
            return;
        }
        this.setState({data: res.data, loading: false, loadingSuccess: true});
    }

    async deleteBucket() {
        const [_, err] = await post(this, "/auth/bucket/delete/" + this.state.name + "/in/" + this.state.location);
        if (err) {
            if (err.response && err.response.status) {
                switch (err.response.status) {
                    case 409:
                        this.setState({errorMessage: "The bucket is not empty. Please empty the bucket first and then try again!"});
                        return;
                    case 400:
                        this.setState({errorMessage: "Invalid bucket name given. Please try again."});
                        return;
                    case 500:
                        this.setState({errorMessage: "Oops, something went wrong. Please try again later."});
                        return;
                }
            }
            this.setState({errorMessage: "error: " + err});
            return;
        }

        this.props.history.push({
            pathname: '/buckets',
            state: {successMessage: `The bucket "${this.state.name}" deletion was successfully queued.`}
        });
    }

    render() {
        const {name, location, data, loading, loadingSuccess, errorMessage} = this.state;

        return (
            <Layout activeMenu="/buckets" isLoggedIn={true}>
                <h1 className="main-heading">Bucket <span className="entity-name">{name}</span></h1>

                {loading && (
                    <>
                        <Spinner animation="border" variant="primary"/> Loading...
                        <br/><br/>
                    </>
                )}

                {errorMessage && <Alert variant="danger">{errorMessage}</Alert>}

                {loadingSuccess && (
                    <>
                        <BucketsNav name={name} location={location}/>
                        <Container>
                            {data.isDeletable ? (
                                <>
                                    <Alert variant="info">
                                        Permanently delete this bucket and all its contents.
                                    </Alert>
                                    <table className="table-ctr">
                                        <tbody>
                                            <tr>
                                                <td>
                                                    <DeleteBucketModal
                                                        bucketName={name}
                                                        hasObjects={data.hasObjects}
                                                        delete={this.deleteBucket}
                                                    />
                                                </td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </>
                            ) : (
                                <Alert variant="info">
                                    Bucket is not deletable because it has object lock enabled.
                                    {data.maxRetentionDate && (
                                        <>
                                            The longest object lock is until {new Date(data.maxRetentionDate).toLocaleDateString()}.
                                            <br />Bucket can be deleted after that time.
                                        </>
                                    )}
                                </Alert>
                            )}
                        </Container>
                        <div className="d-flex justify-content-end mt-3">
                            <Link
                                className="primary-outline btn btn-md"
                                faIcon={faArrowCircleLeft}
                                href="/buckets"
                                label="Back to list"
                            />
                        </div>
                        <br/>
                        <Alert variant="info">
                            <b>For technical configurations, please consult our documentation:</b> <br/>
                            <a href={homepageUrl+'/integrations'} target="_blank" rel="noopener">Integration manuals</a> <br/>
                            <a href={homepageUrl+'/resources/regions'} target="_blank" rel="noopener">Regions</a>
                        </Alert>
                    </>
                )}
            </Layout>
        );
    }
}

export default BucketDeletePage
